import React from 'react';

export default function IconArrow (props) {
    return (
        <svg className={props.className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4">
            <path id="Path_7" data-name="Path 7" d="M0,0H6L2.861,4Z" transform="translate(6 4) rotate(180)" />
        </svg>
    );
}